import { InputField } from '@eventbrite/eds-input-field';
import { gettext } from '@eventbrite/i18n';
import { Field } from 'formik';
import React from 'react';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../../contexts/ConfigContext';
import { IUserContext, useUserContext } from '../../../contexts/UserContext';
import PasswordField from '../PasswordField';

export const FirstAndLastNameFields = ({
    values,
    errors,
    touched,
}: {
    values: any;
    errors: any;
    touched: any;
}) => {
    const firstName = 'firstName';
    const lastName = 'lastName';

    const shouldShowFirstNameErrors = touched.firstName && !!errors.firstName;
    const shouldShowFirstLastNameErrors = touched.lastName && !!errors.lastName;

    return (
        <div className="eds-g-group">
            <div className="eds-g-cell eds-g-cell-6-12 eds-l-pad-right-2">
                <Field
                    name={firstName}
                    id={firstName}
                    component={InputField}
                    value={values.firstName}
                    label={gettext('First Name')}
                    data-testid="auth-lib-first-name-field"
                    style="dynamic"
                    bottomSpacing={3}
                    hasError={shouldShowFirstNameErrors}
                    annotationNote={
                        shouldShowFirstNameErrors && errors?.firstName
                    }
                />
            </div>
            <div className="eds-g-cell eds-g-cell-6-12 eds-l-pad-left-2">
                <Field
                    name={lastName}
                    id={lastName}
                    component={InputField}
                    value={values.lastName}
                    label={gettext('Last Name')}
                    data-testid="auth-lib-first-last-field"
                    style="dynamic"
                    bottomSpacing={3}
                    hasError={shouldShowFirstLastNameErrors}
                    annotationNote={
                        shouldShowFirstLastNameErrors && errors?.lastName
                    }
                />
            </div>
        </div>
    );
};

const SignupFields = ({
    values,
    errors,
    touched,
    onChangePassword,
    onShowPasswordClick,
}: any) => {
    const configContext: IConfigContextProps = useConfigContext();
    const userContext: IUserContext = useUserContext();

    return (
        <div>
            <FirstAndLastNameFields
                values={values}
                errors={errors}
                touched={touched}
            />

            <Field
                name="password"
                component={PasswordField}
                shouldShowStrengthMeter={true}
                value={values.password}
                bottomSpacing={2}
                onChange={() => {
                    onChangePassword?.();
                }}
                onIconClick={() => {
                    onShowPasswordClick?.({
                        contexts: { userContext, configContext },
                    });
                }}
            />
        </div>
    );
};

export default SignupFields;
